'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Lsamples_EnumSample$package$Color$1__T__($thiz, code) {
  $thiz.sA = code;
  return $thiz;
}
export { $ct_Lsamples_EnumSample$package$Color$1__T__ as $ct_Lsamples_EnumSample$package$Color$1__T__ };
/** @constructor */
function $c_Lsamples_EnumSample$package$Color$1() {
  this.sA = null;
}
export { $c_Lsamples_EnumSample$package$Color$1 as $c_Lsamples_EnumSample$package$Color$1 };
$p = $c_Lsamples_EnumSample$package$Color$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$Color$1;
/** @constructor */
function $h_Lsamples_EnumSample$package$Color$1() {
}
export { $h_Lsamples_EnumSample$package$Color$1 as $h_Lsamples_EnumSample$package$Color$1 };
$h_Lsamples_EnumSample$package$Color$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lsamples_EnumSample$package$Color$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bx)));
}
export { $isArrayOf_Lsamples_EnumSample$package$Color$1 as $isArrayOf_Lsamples_EnumSample$package$Color$1 };
var $d_Lsamples_EnumSample$package$Color$1 = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "samples.EnumSample$package$Color$1", ({
  bx: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lsamples_EnumSample$package$Color$1 as $d_Lsamples_EnumSample$package$Color$1 };
